import { Box, Button, Typography, Container, AppBar, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";
import Footer from "../components/Footer";
import heroDoctor from "../assets/hero-doctor.png";
import themeColors from "../theme";
import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export default function LandingPage() {
    const navigate = useNavigate();
    const { teal } = themeColors;
    const { isAuthenticated } = useAuth();
    useEffect(() => {
        if (isAuthenticated) {
            navigate("/dashboard");
        }
    }, [isAuthenticated, navigate]);


    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            {/* Top Navigation Bar */}
            <AppBar position="static" elevation={0} sx={{ bgcolor: "transparent", position: "absolute", zIndex: 10 }}>
                <Toolbar sx={{ px: { xs: 2, md: 6 }, py: 1 }}>
                    <Logo />
                </Toolbar>
            </AppBar>

            {/* Hero Section */}
            <Box
                sx={{
                    width: "100%",
                    minHeight: { xs: "600px", md: "700px" },
                    backgroundImage: `url(${heroDoctor})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: { xs: "center", md: "right center" },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: { xs: "center", md: "flex-start" },
                    textAlign: { xs: "center", md: "left" },
                    color: "#fff",
                    px: { xs: 3, md: 8 },
                    position: "relative",
                    pt: { xs: 12, md: 0 },
                }}
            >
                <Container maxWidth="lg" sx={{ display: "flex", alignItems: "center", minHeight: "inherit" }}>
                    <Box sx={{ maxWidth: { xs: "100%", md: 600 }, mt: { xs: 4, md: 0 } }}>
                        <Typography
                            variant="overline"
                            sx={{
                                color: teal,
                                fontWeight: "bold",
                                fontSize: { xs: "1.2rem", md: "1.5rem" },
                                letterSpacing: 2,
                                mb: 2,
                                display: "block",
                            }}
                        >
                            FOR EMERGENCY MEDICINE CLINICIANS
                        </Typography>
                        <Typography
                            variant="h2"
                            fontWeight="bold"
                            sx={{
                                mb: 3,
                                fontSize: { xs: "2rem", md: "3.5rem" },
                                lineHeight: 1.2,
                                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                            }}
                        >
                            Everything You Need to Manage Your CME—In One Place
                        </Typography>
                        <Typography
                            sx={{
                                mb: 4,
                                fontSize: { xs: "1rem", md: "1.2rem" },
                                lineHeight: 1.6,
                                maxWidth: 550,
                                textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                            }}
                        >
                            Track CME funds, manage credits, explore Emergency Medicine-specific CME courses, receive medical updates, and securely store important documents.
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: { xs: "center", md: "flex-start" } }}>
                            <Button
                                variant="contained"
                                size="large"
                                sx={{
                                    bgcolor: teal,
                                    color: "#fff",
                                    px: 4,
                                    py: 1.5,
                                    fontSize: "1.1rem",
                                    fontWeight: "bold",
                                    "&:hover": { bgcolor: "#006665" },
                                }}
                                onClick={() => navigate("/register")}
                            >
                                REGISTER
                            </Button>
                            <Button
                                variant="outlined"
                                size="large"
                                sx={{
                                    color: "#fff",
                                    borderColor: "#fff",
                                    borderWidth: 2,
                                    px: 4,
                                    py: 1.5,
                                    fontSize: "1.1rem",
                                    fontWeight: "bold",
                                    "&:hover": { borderWidth: 2, bgcolor: "rgba(255,255,255,0.1)" },
                                }}
                                onClick={() => navigate("/login")}
                            >
                                LOG IN
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Box>




            {/* Feature Summary */}
            <Box
                sx={{
                    bgcolor: "#f5f5f5",
                    borderTop: "1px solid #e0e0e0",
                    borderBottom: "1px solid #e0e0e0",
                    py: 2,
                }}
            >
                <Container maxWidth="lg">
                    <Box sx={{ display: "flex", justifyContent: "center", gap: { xs: 2, md: 5 }, flexWrap: "wrap" }}>
                        <Typography sx={{ fontWeight: 500 }}>
                            Funds
                        </Typography>
                        <Typography sx={{ mx: 1, display: { xs: "none", md: "block" } }}>•</Typography>
                        <Typography sx={{ fontWeight: 500 }}>
                            Credits
                        </Typography>
                        <Typography sx={{ mx: 1, display: { xs: "none", md: "block" } }}>•</Typography>
                        <Typography sx={{ fontWeight: 500 }}>
                            Marketplace
                        </Typography>
                        <Typography sx={{ mx: 1, display: { xs: "none", md: "block" } }}>•</Typography>
                        <Typography sx={{ fontWeight: 500 }}>
                            Medical Updates
                        </Typography>
                        <Typography sx={{ mx: 1, display: { xs: "none", md: "block" } }}>•</Typography>
                        <Typography sx={{ fontWeight: 500 }}>
                            Secure Documents
                        </Typography>
                    </Box>
                </Container>
            </Box>

            {/* Built by clinicians section */}
            <Box sx={{ textAlign: "center", py: 4, bgcolor: "#f9f9f9" }}>
                <Typography variant="h5" mb={2}>
                    Built by <span style={{ color: teal, fontWeight: "bold" }}>clinicians</span>, for{" "}
                    <span style={{ color: teal, fontWeight: "bold" }}>clinicians</span>
                </Typography>
            </Box>

            {/* About Us */}
            <Box sx={{ textAlign: "center", py: 3, borderTop: "1px solid #ddd", bgcolor: "#fff" }}>
                <Button variant="text" sx={{ fontWeight: "bold" }} onClick={() => navigate("/about")}>
                    ABOUT US
                </Button>
            </Box>

            {/* Footer */}
            <Footer />
        </Box>
    );
}
